import Vue from 'vue'

const Console = {
  methods: {
    logConsole: obj => {
      if (process.env.NODE_ENV.toUpperCase() !== 'production'.toUpperCase()) {
        console.log(obj)
      }
    }
  }
}

Vue.mixin(Console)



// WEBPACK FOOTER //
// ./src/mixins/console.js